import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { save } from './api-cronograma-aula';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { addCronogramasAula, updateCronogramasAula, setCronogramaAula as setCronogramaAulaRedux } from './actions/actions';
import TextFieldTime from '../../UI/TextFieldTime';
import dayjs from 'dayjs';
import { errorMessage } from '../../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    },
    fieldGrid: {
        margin: '10px'
    }
});

export default function CronogramaAulaForm() {
    const classes = useStyles();
    const [cronogramaAula, setCronogramaAula] = useState(useSelector(state => state.cronogramaAula));
    const dispatch = useDispatch();
    const [loadingSave, setLoadingSave] = useState(false);

    const handleChange = (event) => {
        setCronogramaAula({
            ...cronogramaAula,
            [event.target.name]: event.target.value
        })
    }

    const handleHorarioInicio = (data) => {
        setCronogramaAula((prevState) => ({
            ...prevState,
            horarioInicio: dayjs(data)
        }));
    }

    const handleHorarioFim = (data) => {
        setCronogramaAula((prevState) => ({
            ...prevState,
            horarioFim: dayjs(data)
        }));
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        const eNovo = cronogramaAula.eNovo;
        setLoadingSave(true);
        save(cronogramaAula).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    if (eNovo) {
                        dispatch(addCronogramasAula(data));
                    } else {
                        dispatch(updateCronogramasAula(data));
                    }
                    dispatch(setCronogramaAulaRedux(data));
                    setCronogramaAula(data);
                }
            }
            setLoadingSave(false);



        })

    }




    return (
        <div>
            <Container className={classes.paper} component={Paper}>
                <CloseIcon
                    fontSize='small'
                    onClick={() => dispatch(setCronogramaAulaRedux(null))} className={classes.closeIcon} />
                <form onSubmit={clickSubmit}>
                    <Grid className={classes.fieldGrid}>
                        <TextField
                            variant="outlined"
                            required
                            size="small"
                            onChange={handleChange}
                            label="Descrição"
                            name="descricao"
                            value={cronogramaAula && cronogramaAula.descricao ?
                                cronogramaAula.descricao : ''}
                        />

                    </Grid>
                    <Grid className={classes.fieldGrid}>
                        <TextField
                            variant="outlined"
                            required
                            size="small"
                            onChange={handleChange}
                            label="Ordem Aula"
                            name="ordemAula"
                            value={cronogramaAula && cronogramaAula.ordemAula ?
                                cronogramaAula.ordemAula : ''}
                        />

                    </Grid>
                    <Grid className={classes.fieldGrid}>
                        <TextFieldTime
                            required
                            label="Horário Início"
                            value={cronogramaAula && cronogramaAula.horarioInicio ? cronogramaAula.horarioInicio : null}
                            onChange={handleHorarioInicio}

                        />
                    </Grid>
                    <Grid className={classes.fieldGrid}>
                        <TextFieldTime
                            required
                            label="Horário Fim"
                            value={cronogramaAula && cronogramaAula.horarioFim ? cronogramaAula.horarioFim : null}
                            onChange={handleHorarioFim}
                        />
                    </Grid>

                    <Button

                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={loadingSave}
                    >
                        {loadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                        Salvar
                    </Button>
                </form>
            </Container>

        </div>
    );
}